import styled from "styled-components";

export const AppContainer = styled.div`
  min-height: var(--app-height, 100svh);
  background: #f7f9fc;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  box-sizing: border-box;

`;

export const BleedBackgroundHost = styled.div`
  position: fixed;
  inset: 0;
  min-height: var(--app-height, 100svh);
  pointer-events: none;
  z-index: 0;
`;

export const MainContent = styled.main`
  flex: 1;
  min-width: 0;
  max-width: 100%;
  display: flex;
  justify-content: center;
  align-items: stretch;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
`;
